// ViewDeliveryChalan.js
import React, { useEffect, useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import UniversalInvoicePrint from "./UniversalInvoicePrint";
import api from "../Service/api";
import "./Purchases.css";

function ViewDeliveryChalan() {
  const getLocalDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const [chalans, setChalans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updateChalan, setUpdateChalan] = useState(null);
  const [allProducts, setAllProducts] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [startDate, setStartDate] = useState(getLocalDate);
  const [endDate, setEndDate] = useState(getLocalDate);
  const [filteredChalans, setFilteredChalans] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [fullScreenImage, setFullScreenImage] = useState(null);
  
  const printRef = useRef();
  const [printChalan, setPrintChalan] = useState(null);
  const [loggedInUser, setLoggedInUser] = useState(null);

  useEffect(() => {
    const phone = localStorage.getItem("userPhone");
    console.log("PHONE FROM LOCALSTORAGE:", phone);
    
    if (!phone) return;
    
    api.get(`/authentication/userData/${phone}`)
      .then(res => {
        console.log("USER DATA API RESPONSE:", res.data);
        setLoggedInUser(res.data.additionalDetail);
      })
      .catch(err => console.error("USER DATA API ERROR:", err));
  }, []);
  
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: printChalan ? `Delivery-Challan-${printChalan.invoiceNumber}` : "Delivery-Challan",
  });
  
  const handlePrintChalan = (chalan) => {
    const printData = {
      invoiceNumber: chalan.invoiceNumber,
      customerName: chalan.customerName,
      products: chalan.deliveryChalanDtos || [],
      user: loggedInUser,
      invoiceDate: chalan.deliveryChalanDtos?.[0]?.deliveryEntryTime?.split('T')[0] || new Date().toISOString().split('T')[0],
      description: chalan.description || ""
    };
    setPrintChalan(printData);
    setTimeout(() => handlePrint(), 300);
  };

  useEffect(() => {
    loadChalans();
    loadProductList();
    loadCategoryList();
  }, []);

  useEffect(() => {
    if (!loading) {
      loadChalans();
    }
  }, [startDate, endDate]);

  const loadChalans = async () => {
    try {
      setLoading(true);
      let url = "/chalan/get-delivery-chalan";
      const params = new URLSearchParams();
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);
      const queryString = params.toString();
      if (queryString) url += `?${queryString}`;
      const res = await api.get(url);
      console.log("Chalan API Response:", res.data);
      let chalanData = [];
      if (Array.isArray(res.data)) {
        chalanData = res.data;
      } else if (res.data.code === 1 && res.data.additionalDetail) {
        chalanData = res.data.additionalDetail;
      } else if (res.data.code === 1 && Array.isArray(res.data)) {
        chalanData = res.data;
      }
      setChalans(chalanData);
      setFilteredChalans(chalanData);
    } catch (err) {
      console.error("Error fetching delivery chalans", err);
      setChalans([]);
      setFilteredChalans([]);
    } finally {
      setLoading(false);
    }
  };

  const resetFilters = () => {
    setStartDate("");
    setEndDate("");
    setSearchText("");
    loadChalans();
  };

  const handleSearch = (text) => {
    setSearchText(text);
    if (!text) {
      setFilteredChalans(chalans);
      return;
    }
    const filtered = chalans.filter(chalan => {
      const customerMatch = chalan.customerName?.toLowerCase().includes(text.toLowerCase());
      const productMatch = (chalan.deliveryChalanDtos || []).some(
        p => p.productName?.toLowerCase().includes(text.toLowerCase())
      );
      const chalanMatch = chalan.invoiceNumber?.toString().includes(text);
      return customerMatch || productMatch || chalanMatch;
    });
    setFilteredChalans(filtered);
  };

  const loadProductList = async () => {
    try {
      const res = await api.get("/product/names-prices");
      setAllProducts(res.data.additionalDetail || []);
    } catch (err) {
      console.error("Error loading product list", err);
      setAllProducts([]);
    }
  };

  const loadCategoryList = async () => {
    try {
      const res = await api.get("/api/category/getCategories");
      setCategoryList(res.data.additionalDetail || []);
    } catch (err) {
      setCategoryList([
        { categoryName: "packet" },
        { categoryName: "roll" },
        { categoryName: "reel" },
        { categoryName: "tota" },
        { categoryName: "box" },
        { categoryName: "kg" },
        { categoryName: "bottle" },
      ]);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-IN', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    } catch (error) {
      return dateString;
    }
  };

  const openUpdateForm = (chalan) => {
    console.log("Opening update form for chalan:", chalan);
    const copy = JSON.parse(JSON.stringify(chalan || {}));
    if (copy.deliveryChalanDtos && copy.deliveryChalanDtos.length > 0) {
      console.log("First item structure:", copy.deliveryChalanDtos[0]);
    }
    copy.deliveryChalanDtos = (copy.deliveryChalanDtos || []).map(item => ({
      ...item,
      quantity: item.quantity ?? 0,
      size: item.size ?? "",
      length: item.length ?? "",        // ✅ Add length
      ktae: item.ktae ?? "",
      gram: item.gram ?? "",
      particulars: item.particulars ?? ""
    }));
    setUpdateChalan(copy);
  };

  const handleUpdateProductChange = (index, field, value) => {
    if (!updateChalan) return;
    const products = [...(updateChalan.deliveryChalanDtos || [])];
    const prod = { ...products[index] };
    prod[field] = value;

    if (field === "productName") {
      const match = allProducts.find(
        (ap) => (ap.productName || "").toLowerCase() === value.toLowerCase()
      );
      if (match) {
        prod.category = match.category ?? prod.category;
        const catLower = (match.category || "").toLowerCase();
        if (catLower === 'roll' && match.size) {
          prod.size = match.size;
        }
      }
    }

    const currentCategory = (prod.category || "").toLowerCase();
    if (field === "quantity" && (currentCategory === "reel" || currentCategory === "tota" || currentCategory === "roll")) {
      const valueNum = parseFloat(value) || 0;
      prod.size = valueNum;
    }

    if (field === "category") {
      const cat = (value || "").toLowerCase();
      if (cat !== 'packet') {
        prod.ktae = '';
        prod.gram = '';
      }
      if (!['packet', 'roll', 'reel', 'tota', 'box'].includes(cat)) {
        prod.size = '';
      }
      if (cat !== 'box') {
        prod.particulars = '';
      }
      // ✅ Reset length if new category is not reel or tota
      if (cat !== 'reel' && cat !== 'tota') {
        prod.length = '';
      }
    }

    products[index] = prod;
    setUpdateChalan({ ...updateChalan, deliveryChalanDtos: products });
  };

  const handleUpdateChalanField = (field, value) => {
    if (!updateChalan) return;
    setUpdateChalan({ ...updateChalan, [field]: value });
  };

  const saveUpdate = async () => {
    if (!updateChalan) return alert("No chalan to update");
    try {
      const toSend = {
        invoiceNumber: updateChalan.invoiceNumber,
        customerName: updateChalan.customerName,
        description: updateChalan.description || "",
        deliveryChalanDtos: (updateChalan.deliveryChalanDtos || []).map(item => {
          const cat = (item.category || "").toLowerCase();
          const baseItem = {
            productName: item.productName,
            category: item.category,
            quantity: parseInt(item.quantity) || 0,
            deliveryEntryTime: new Date().toISOString(),
            recordUpdatedTime: new Date().toISOString(),
            isActive: true
          };
          
          if (cat === 'packet') {
            return {
              ...baseItem,
              size: item.size || null,
              ktae: item.ktae || null,
              gram: item.gram || null
            };
          } else if (cat === 'roll') {
            return {
              ...baseItem,
              size: item.size || null
            };
          } else if (cat === 'reel' || cat === 'tota') {
            // ✅ For reel/tota, send length, not size
            return {
              ...baseItem,
              length: item.length || null
            };
          } else if (cat === 'box') {
            return {
              ...baseItem,
              size: item.size || null,
              particulars: item.particulars || null
            };
          } else {
            return baseItem;
          }
        })
      };
      const chalanNumber = toSend.invoiceNumber;
      const res = await api.put(`/chalan/delivery-chalan/${chalanNumber}`, toSend);
      alert(res.data.additionalDetail || "Delivery Chalan updated successfully");
      setUpdateChalan(null);
      loadChalans();
    } catch (err) {
      console.error("Update failed", err);
      alert("Update failed! See console.");
    }
  };

  const deleteChalan = async (chalanNumber) => {
    if (!window.confirm(`Delete Delivery Chalan #${chalanNumber}?`)) return;
    try {
      const res = await api.delete(`/chalan/delivery-chalan/${chalanNumber}`);
      alert(res.data.additionalDetail || "Deleted successfully!");
      loadChalans();
    } catch (err) {
      console.error("Delete failed", err);
      alert("Delete failed");
    }
  };

  if (loading) return <div className="loading-text">Loading Delivery Chalans…</div>;

  return (
    <div className="purchase-container">
      <h2 className="page-title">📄 Delivery Chalans</h2>

      <div style={{ marginBottom: 20 }}>
        <input
          type="text"
          placeholder="Search by customer, product, or chalan number..."
          value={searchText}
          onChange={(e) => handleSearch(e.target.value)}
          className="read-only-input"
          style={{ width: 350, padding: 6 }}
        />
      </div>

      <div style={{ 
        marginBottom: 20, 
        display: 'flex', 
        gap: '15px', 
        alignItems: 'center',
        flexWrap: 'wrap'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <label style={{ fontWeight: '500', color: '#000', fontSize: '14px' }}>From:</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="read-only-input"
            style={{ padding: '6px', borderRadius: '4px' }}
          />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <label style={{ fontWeight: '500', color: '#000', fontSize: '14px' }}>To:</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="read-only-input"
            style={{ padding: '6px', borderRadius: '4px' }}
            min={startDate}
          />
        </div>
        <button onClick={resetFilters} className="remove-btn" style={{ padding: '6px 12px', fontSize: '14px', marginLeft: '10px' }}>
          Clear Filters
        </button>
        {(startDate || endDate || searchText) && (
          <span style={{ fontSize: '14px', color: '#555', marginLeft: '10px' }}>
            Showing {filteredChalans.length} of {chalans.length} chalans
            {searchText && ` for "${searchText}"`}
            {startDate && ` from ${startDate}`}
            {endDate && ` to ${endDate}`}
          </span>
        )}
      </div>

      {filteredChalans.length === 0 && !loading && (
        <p style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
          {searchText || startDate || endDate 
            ? "No delivery chalans found matching your search/filters." 
            : "No delivery chalans found."}
        </p>
      )}

      {filteredChalans.map((chalan) => {
        const products = chalan.deliveryChalanDtos || [];
        const hasPacket = products.some(p => (p.category || "").toLowerCase() === "packet");
        const hasRoll = products.some(p => (p.category || "").toLowerCase() === "roll");
        const hasReelOrTota = products.some(p => {
          const cat = (p.category || "").toLowerCase();
          return cat === "reel" || cat === "tota";
        });
        const hasBox = products.some(p => (p.category || "").toLowerCase() === "box");
        // ✅ For reel/tota, show Length column instead of Size
        const showSize = hasPacket || hasRoll || hasBox;
        const showLength = hasReelOrTota;
        const showKtae = hasPacket;
        const showGram = hasPacket;
        const showParticulars = hasBox;

        return (
          <div key={chalan.invoiceNumber} className="invoice-box">
            <h3 className="invoice-title" style={{ color: "#000" }}>
              Delivery Chalan #{chalan.invoiceNumber} – {chalan.customerName}
            </h3>

            <div style={{ marginBottom: "10px", display: "flex", gap: "10px" }}>
              <button className="save-btn" onClick={() => openUpdateForm(chalan)}>Update</button>
              <button className="remove-btn" onClick={() => deleteChalan(chalan.invoiceNumber)}>Delete</button>
              <button
                className="print-dc-btn"
                onClick={() => handlePrintChalan(chalan)}
                style={{
                  backgroundColor: "#17a2b8",
                  color: "white",
                  border: "none",
                  padding: "6px 12px",
                  borderRadius: "4px",
                  cursor: "pointer"
                }}
              >
                Print DC
              </button>
            </div>

            <div className="purchase-table-container">
              <div className="table-scroll-wrapper">
                <table className="purchase-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Product Name</th>
                      <th>Category</th>
                      <th>Quantity</th>
                      {showSize && <th>Size</th>}
                      {showLength && <th>Size</th>}
                      {showKtae && <th>Ktae</th>}
                      {showGram && <th>Gram</th>}
                      {showParticulars && <th>Particulars</th>}
                      <th>Delivery Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {products.map((item, idx) => {
                      const cat = (item.category || "").toLowerCase();
                      const isPacket = cat === "packet";
                      const isRoll = cat === "roll";
                      const isReelOrTota = cat === "reel" || cat === "tota";
                      const isBox = cat === "box";

                      return (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td>{item.productName}</td>
                          <td>{item.category}</td>
                          <td>{item.quantity}</td>
                          {showSize && (
                            <td>
                              {isPacket || isRoll || isBox ? (item.size || "-") : "-"}
                            </td>
                          )}
                          {showLength && (
                            <td>
                              {isReelOrTota ? (item.length || "-") : "-"}
                            </td>
                          )}
                          {showKtae && (
                            <td>{isPacket ? (item.ktae || "-") : "-"}</td>
                          )}
                          {showGram && (
                            <td>{isPacket ? (item.gram || "-") : "-"}</td>
                          )}
                          {showParticulars && (
                            <td>{isBox ? (item.particulars || "-") : "-"}</td>
                          )}
                          <td>{formatDate(item.deliveryEntryTime)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>

            {/* UPDATE FORM */}
            {updateChalan && updateChalan.invoiceNumber === chalan.invoiceNumber && (
              <div className="invoice-box" style={{ background: "#fff7e6", marginTop: 12 }}>
                <h3 className="invoice-title">Update Delivery Chalan #{updateChalan.invoiceNumber}</h3>

                <div className="purchase-table-container">
                  <div className="table-scroll-wrapper">
                    <table className="purchase-table">
                      <thead>
                        <tr>
                          <th>Product Name</th>
                          <th>Category</th>
                          <th>Quantity</th>
                          {(() => {
                            const updateCategories = (updateChalan.deliveryChalanDtos || []).map(
                              p => (p.category || "").toLowerCase()
                            );
                            const showSizeCol = updateCategories.some(c => ["packet", "roll", "box"].includes(c));
                            const showLengthCol = updateCategories.some(c => c === "reel" || c === "tota");
                            const showKtaeCol = updateCategories.includes("packet");
                            const showGramCol = updateCategories.includes("packet");
                            const showParticularsCol = updateCategories.includes("box");
                            return (
                              <>
                                {showSizeCol && <th>Size</th>}
                                {showLengthCol && <th>Size</th>}
                                {showKtaeCol && <th>Ktae</th>}
                                {showGramCol && <th>Gram</th>}
                                {showParticularsCol && <th>Particulars</th>}
                              </>
                            );
                          })()}
                        </tr>
                      </thead>
                      <tbody>
                        {(updateChalan.deliveryChalanDtos || []).map((item, idx) => {
                          const cat = (item.category || "").toLowerCase();
                          const updateCategories = (updateChalan.deliveryChalanDtos || []).map(
                            p => (p.category || "").toLowerCase()
                          );
                          const showSizeCol = updateCategories.some(c => ["packet", "roll", "box"].includes(c));
                          const showLengthCol = updateCategories.some(c => c === "reel" || c === "tota");
                          const showKtaeCol = updateCategories.includes("packet");
                          const showGramCol = updateCategories.includes("packet");
                          const showParticularsCol = updateCategories.includes("box");
                          
                          const selectedProduct = allProducts.find(ap => ap.productName === item.productName);
                          const stockQuantity = selectedProduct?.stockQuantity;
                          const stockByWeight = selectedProduct?.stockByWeight;
                          const packetStockByVariant = selectedProduct?.packetStockByVariant;
                          const isPacket = cat === "packet";
                          const isRoll = cat === "roll";
                          const isReelOrTota = cat === "reel" || cat === "tota";
                          const isBox = cat === "box";
                          
                          let hasStock = true;
                          if (selectedProduct && item.productName) {
                            if ((isReelOrTota || isRoll) && stockByWeight) {
                              hasStock = Object.values(stockByWeight).some(qty => qty > 0);
                            } else if (isPacket && packetStockByVariant) {
                              hasStock = Object.values(packetStockByVariant).some(qty => qty > 0);
                            } else {
                              hasStock = (stockQuantity !== undefined && stockQuantity > 0);
                            }
                          }

                          return (
                            <tr key={idx}>
                              <td style={{ position: 'relative' }}>
                                <input
                                  list={`products-${idx}`}
                                  value={item.productName || ""}
                                  onChange={(e) => handleUpdateProductChange(idx, "productName", e.target.value)}
                                  className="read-only-input"
                                  style={{
                                    borderColor: (!hasStock && item.productName) ? '#ff4444' : '',
                                    backgroundColor: (!hasStock && item.productName) ? '#fff0f0' : ''
                                  }}
                                />
                                <datalist id={`products-${idx}`}>
                                  {allProducts.map((ap, i) => {
                                    const apCategoryLower = (ap.category || "").toLowerCase();
                                    const isApReelOrTotaOrRoll = apCategoryLower === 'reel' || apCategoryLower === 'tota' || apCategoryLower === 'roll';
                                    const isApPacket = apCategoryLower === 'packet';
                                    
                                    if (isApReelOrTotaOrRoll && ap.stockByWeight && Object.keys(ap.stockByWeight).length > 0) {
                                      const nonZeroStocks = Object.entries(ap.stockByWeight).filter(([_, qty]) => qty > 0);
                                      if (nonZeroStocks.length > 0) {
                                        return <option key={i} value={ap.productName}>{ap.productName} [{nonZeroStocks.map(([weight, qty]) => `${weight}: ${qty}`).join(', ')}]</option>;
                                      } else {
                                        return <option key={i} value={ap.productName}>{ap.productName} (Out of Stock)</option>;
                                      }
                                    } else if (isApPacket && ap.packetStockByVariant && Object.keys(ap.packetStockByVariant).length > 0) {
                                      const nonZeroStocks = Object.entries(ap.packetStockByVariant).filter(([_, qty]) => qty > 0);
                                      if (nonZeroStocks.length > 0) {
                                        return <option key={i} value={ap.productName}>{ap.productName} [{nonZeroStocks.map(([variant, qty]) => `${variant}: ${qty}`).join(', ')}]</option>;
                                      } else {
                                        return <option key={i} value={ap.productName}>{ap.productName} (Out of Stock)</option>;
                                      }
                                    } else {
                                      return <option key={i} value={ap.productName}>{ap.productName} {ap.stockQuantity !== undefined ? `(Stock: ${ap.stockQuantity})` : ''}{ap.category === 'roll' && ap.size ? ` [Size: ${ap.size}]` : ''}</option>;
                                    }
                                  })}
                                </datalist>
                                
                                {item.productName && isPacket && selectedProduct && (
                                  <div style={{ marginTop: '4px' }}>
                                    {(() => {
                                      const totalStock = selectedProduct.stockQuantity || 0;
                                      const variantEntries = packetStockByVariant ? Object.entries(packetStockByVariant).filter(([_, qty]) => qty > 0) : [];
                                      const hasVariantStock = totalStock > 0;
                                      if (!hasVariantStock) {
                                        return (
                                          <div style={{ color: '#ff4444', backgroundColor: '#ffebee', padding: '6px 8px', borderRadius: '4px', border: '1px solid #ff4444', fontSize: '11px' }}>
                                            <strong>⚠️ Out of Stock</strong>
                                          </div>
                                        );
                                      }
                                      return (
                                        <div style={{ color: '#0a8938', backgroundColor: '#f8f9fa', padding: '6px 8px', borderRadius: '4px', border: '1px solid #0a8938', fontSize: '11px' }}>
                                          <div><strong>📦 Total Stock: {totalStock}</strong></div>
                                          {variantEntries.length > 0 && (
                                            <>
                                              <div style={{ fontSize: '10px', marginTop: '4px', color: '#555' }}>Breakdown by variant:</div>
                                              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '2px' }}>
                                                {variantEntries.map(([variant, qty]) => (
                                                  <span key={variant} style={{ backgroundColor: '#e8f5e9', padding: '2px 6px', borderRadius: '12px', fontSize: '9px', fontWeight: 'bold' }}>
                                                    {variant}: {qty}
                                                  </span>
                                                ))}
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      );
                                    })()}
                                  </div>
                                )}
                                
                                {item.productName && (isReelOrTota || isRoll) && stockByWeight && Object.keys(stockByWeight).length > 0 && (
                                  <div style={{ fontSize: '10px', color: '#0a8938', marginTop: '2px', fontWeight: '500', backgroundColor: '#e8f5e9', padding: '2px 4px', borderRadius: '4px' }}>
                                    📊 {Object.entries(stockByWeight).map(([w, q]) => `${w}: ${q}`).join(', ')}
                                  </div>
                                )}
                                
                                {item.productName && !isPacket && !isReelOrTota && !isRoll && stockQuantity !== undefined && (
                                  <div style={{ fontSize: '11px', color: stockQuantity <= 0 ? '#ff4444' : '#0a8938', marginTop: '2px', fontWeight: '500' }}>
                                    📦 {stockQuantity <= 0 ? 'Out of Stock' : `In Stock: ${stockQuantity}`}
                                  </div>
                                )}
                                
                                {isRoll && !item.size && item.productName && (
                                  <div style={{ fontSize: '11px', color: '#ff4444', marginTop: '2px', fontWeight: '500' }}>
                                    ⚠️ Size is required for roll products
                                  </div>
                                )}
                                {(isReelOrTota || isRoll) && (!item.quantity || parseFloat(item.quantity) <= 0) && item.productName && (
                                  <div style={{ fontSize: '11px', color: '#ff9800', marginTop: '2px', fontWeight: '500' }}>
                                    ⚡ Enter {isRoll ? 'meters/units' : 'weight in kg'} in the Quantity column
                                  </div>
                                )}
                                {/* ✅ Length hint for reel/tota */}
                                {isReelOrTota && (!item.length || parseFloat(item.length) <= 0) && item.productName && (
                                  <div style={{ fontSize: '11px', color: '#ff9800', marginTop: '2px', fontWeight: '500' }}>
                                    ⚡ Length is required (e.g., meters)
                                  </div>
                                )}
                              </td>
                              <td>
                                <input
                                  list={`categories-${idx}`}
                                  value={item.category || ""}
                                  onChange={(e) => handleUpdateProductChange(idx, "category", e.target.value)}
                                  className="read-only-input"
                                />
                                <datalist id={`categories-${idx}`}>
                                  {Array.isArray(categoryList) && categoryList.map((c, i) => <option key={i} value={c.categoryName} />)}
                                </datalist>
                              </td>
                              <td>
                                <input
                                  type="number"
                                  value={item.quantity ?? ""}
                                  onChange={(e) => handleUpdateProductChange(idx, "quantity", e.target.value)}
                                  className="read-only-input"
                                  placeholder={(isReelOrTota) ? "Weight in kg" : (isRoll ? "Quantity in meters" : "Quantity")}
                                  step={(isReelOrTota) ? "1" : "0.01"}
                                    onWheel={(e) => e.preventDefault()}   // ✅ add this

                                />
                              </td>
                              {showSizeCol && (
                                <td>
                                  {(isPacket || isRoll || isBox) ? (
                                    <input
                                      type={isBox ? "text" : "number"}
                                      value={item.size ?? ""}
                                      onChange={(e) => handleUpdateProductChange(idx, "size", e.target.value)}
                                      className="read-only-input"
                                      placeholder="Size"
                                        onWheel={(e) => e.preventDefault()}   // ✅ add this

                                    />
                                  ) : (
                                    <input
                                      type="text"
                                      value=""
                                      className="read-only-input"
                                      disabled={true}
                                      style={{ backgroundColor: '#f0f0f0' }}
                                      placeholder="N/A"
                                    />
                                  )}
                                </td>
                              )}
                              {showLengthCol && (
                                <td>
                                  {isReelOrTota ? (
                                    <input
                                      type="number"
                                      step="any"
                                      value={item.length ?? ""}
                                      onChange={(e) => handleUpdateProductChange(idx, "length", e.target.value)}
                                      className="read-only-input"
                                      placeholder="Length"
                                        onWheel={(e) => e.preventDefault()}   // ✅ add this

                                    />
                                  ) : (
                                    <input
                                      type="text"
                                      value=""
                                      className="read-only-input"
                                      disabled={true}
                                      style={{ backgroundColor: '#f0f0f0' }}
                                      placeholder="N/A"
                                    />
                                  )}
                                </td>
                              )}
                              {showKtaeCol && (
                                <td>
                                  {isPacket ? (
                                    <input
                                      type="number"
                                      value={item.ktae ?? ""}
                                      onChange={(e) => handleUpdateProductChange(idx, "ktae", e.target.value)}
                                      className="read-only-input"
                                      placeholder="Ktae"
                                        onWheel={(e) => e.preventDefault()}   // ✅ add this

                                    />
                                  ) : (
                                    <input
                                      type="text"
                                      value=""
                                      className="read-only-input"
                                      disabled={true}
                                      style={{ backgroundColor: '#f0f0f0' }}
                                      placeholder="N/A"
                                    />
                                  )}
                                </td>
                              )}
                              {showGramCol && (
                                <td>
                                  {isPacket ? (
                                    <input
                                      type="number"
                                      value={item.gram ?? ""}
                                      onChange={(e) => handleUpdateProductChange(idx, "gram", e.target.value)}
                                      className="read-only-input"
                                      placeholder="Gram"
                                        onWheel={(e) => e.preventDefault()}   // ✅ add this

                                    />
                                  ) : (
                                    <input
                                      type="text"
                                      value=""
                                      className="read-only-input"
                                      disabled={true}
                                      style={{ backgroundColor: '#f0f0f0' }}
                                      placeholder="N/A"
                                    />
                                  )}
                                </td>
                              )}
                              {showParticularsCol && (
                                <td>
                                  {isBox ? (
                                    <input
                                      type="text"
                                      value={item.particulars ?? ""}
                                      onChange={(e) => handleUpdateProductChange(idx, "particulars", e.target.value)}
                                      className="read-only-input"
                                      placeholder="Particulars"
                                    />
                                  ) : (
                                    <input
                                      type="text"
                                      value=""
                                      className="read-only-input"
                                      disabled={true}
                                      style={{ backgroundColor: '#f0f0f0' }}
                                      placeholder="N/A"
                                    />
                                  )}
                                </td>
                              )}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="invoice-summary" style={{ color: "#000", marginTop: 10 }}>
                  <p>
                    <strong>Customer Name:</strong>{" "}
                    <input
                      type="text"
                      value={updateChalan.customerName ?? ""}
                      onChange={(e) => handleUpdateChalanField("customerName", e.target.value)}
                      className="read-only-input"
                      style={{ width: "300px" }}
                    />
                  </p>
                  <p>
                    <strong>Description:</strong>{" "}
                    <input
                      type="text"
                      value={updateChalan.description || ""}
                      onChange={(e) => handleUpdateChalanField("description", e.target.value)}
                      className="read-only-input"
                      style={{ width: "60%" }}
                      placeholder="Optional description"
                    />
                  </p>
                </div>

                <div style={{ marginTop: 12, display: "flex", gap: 10 }}>
                  <button className="save-btn" onClick={saveUpdate}>Save Updated Chalan</button>
                  <button className="remove-btn" onClick={() => setUpdateChalan(null)}>Cancel</button>
                </div>
              </div>
            )}

            <div className="invoice-summary" style={{ color: "#000", marginTop: 10 }}>
              <p><strong>Description:</strong> {chalan.description || "—"}</p>
              <p><strong>Total Items:</strong> {products.length}</p>
            </div>
          </div>
        );
      })}
      
      <div style={{ position: "absolute", top: "-9999px" }}>
        <UniversalInvoicePrint ref={printRef} invoice={printChalan} type="dc" />
      </div>
    </div>
  );
}

export default ViewDeliveryChalan;